import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import './css/Inspection.css';

export default function Inspection() {
  const navigate = useNavigate();
  const goToReport = async () => {
    var uuid;
    try {
      const response = await fetch('/catalog/0');
      const newData = await response.json();
      uuid = newData[0].uuid;
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      navigate(`/report/${uuid}`);
    }
  };
  
  return(
    <>
      <section className="inspection-page">
        <div className="inspection-page-container">
          <div className="inspection-page-subtitle">
            STRUCTURAL INTEGRITY INSPECTION
          </div>
          <h2 className="inspection-page-title">
            More Than Just "Accident" or "Non-Accident"
          </h2>
          <p className="inspection-page-description">
            Every used vehicle has a history, but not every accident is the same.
            P2PAUTO evaluates the <strong style={{color:"#111827"}}>severity of structural damage</strong> instead of simply declaring a vehicle as accident or non-accident. Our inspection helps buyers understand the vehicle's true structural condition before making an informed purchase decision.
          </p>
          <div className="inspection-page-cards">
            <div className="inspection-page-card inspection-page-green">
              <div className="inspection-page-icon">🟢</div>
              <h3>Non-Accident</h3>
              <p>
                No observable evidence of accident-related structural repairs. Only normal wear consistent with age and usage.
              </p>
            </div>
          <div className="inspection-page-card inspection-page-yellow">
            <div className="inspection-page-icon">🟡</div>
              <h3>Minor Accident</h3>
              <p>
                Repairs limited to non-structural body panels with no observable damage affecting the chassis or structural members.
              </p>
            </div>
            <div className="inspection-page-card inspection-page-red">
              <div className="inspection-page-icon">🔴</div>
              <h3>Major Accident</h3>
              <p>
                Structural damage involving the chassis or safety-critical components that may affect vehicle safety, performance or usability.
              </p>
            </div>
          </div>
          <div className="inspection-page-bottom">
            <p>
              <b>Our role isn't to tell you what to buy.</b><br/><br/>  

              We provide clear, objective information so you understand the vehicle's structural condition before making your decision. Every buyer has different expectations, and every inspected vehicle deserves transparent disclosure.
            </p>
            <div onClick={goToReport} className="inspection-page-btn">
              VIEW SAMPLE REPORT
            </div>
          </div>
        </div>
      </section>
    </>
  )
}